import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck } = FiIcons;

const plans = [
  {
    name: 'Solo',
    price: '$19',
    description: 'For founders building one brand with intention.',
    features: ['1 brand', '20 posts per month', 'Platform caption variants', 'Review and approval workflow']
  },
  {
    name: 'Growing',
    price: '$49',
    description: 'For entrepreneurs managing a few active brands.',
    features: ['3 brands', '75 posts per month', 'Learnings log', 'Priority creative drafts'],
    recommended: true
  },
  {
    name: 'Agency',
    price: '$99',
    description: 'For teams creating content across a portfolio.',
    features: ['10 brands', 'Unlimited post drafts', 'Shared brand workspaces', 'Advanced review history']
  }
];

function PricingPlans({ onEnterApp }) {
  return (
    <section className="landing-section pricing-section" id="pricing">
      <div className="pricing-heading">
        <div>
          <span className="landing-kicker">Simple plans</span>
          <h2>Start small. <em>Grow into it.</em></h2>
        </div>
        <p>Choose the workspace that matches the way you create today.</p>
      </div>

      <div className="pricing-grid">
        {plans.map((plan) => (
          <article className={`pricing-card ${plan.recommended ? 'recommended' : ''}`} key={plan.name}>
            {plan.recommended && <span className="recommended-label">Most popular</span>}
            <h3>{plan.name}</h3>
            <div className="plan-price">
              {plan.price}<small>/mo</small>
            </div>
            <p className="plan-description">{plan.description}</p>
            <ul>
              {plan.features.map((feature) => (
                <li key={feature}>
                  <SafeIcon icon={FiCheck} />
                  {feature}
                </li>
              ))}
            </ul>
            <button
              className={plan.recommended ? 'landing-primary' : 'plan-button'}
              style={plan.recommended ? { background: '#19382f' } : undefined}
              onClick={onEnterApp}
            >
              Get started
            </button>
          </article>
        ))}
      </div>
      <p className="pricing-note">Mock plans shown for preview purposes. No payment is required to explore DalePost.</p>
    </section>
  );
}

export default PricingPlans;